<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import { Permission } from "../../../../../types/auth";
import { FilterField, TableField } from "../../../../../components/table/table";
import ListTemplate from "../../../../../components/ui/common/ListTemplate.vue";

const props = defineProps<{
  data?: any | [];
  unit_of_measures?: any | [];
  permissions?: Permission[];
  item?: any | null;
}>();

const endPoint = "";
const title = "Batches";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");
const refreshData = ref(false);

const rows = ref<any[]>(props.data);

const fields: TableField[] = [
  {
    name: "warehouse",
    caption: "Warehouse",
    sortable: true,
    fieldType: "text",
  },
  {
    name: "variant_name",
    caption: "Variant",
    sortable: true,
    fieldType: "text",
  },
  { name: "batch_no", caption: "Batch No", sortable: true, fieldType: "text" },
  {
    name: "expiry_date",
    caption: "Expiry Date",
    sortable: true,
    fieldType: "date",
  },
  {
    name: "warehouse_shelf",
    caption: "Shelf",
    sortable: true,
    fieldType: "text",
  },
  { name: "on_hand", caption: "On Hand", sortable: true, fieldType: "number" },
  { name: "active", caption: "active", sortable: false, fieldType: "status" },
];

const filterFields: FilterField[] = [
  {
    name: "active",
    label: "Status",
    type: "select",
    value: "",
    options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
];

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data: any) => {
  selectedData.value = data;
};

onMounted(() => {
  rows.value = props.data;
});

watch(
  () => props.data,
  () => {
    rows.value = props.data;
  },
  { immediate: true }
);
</script>

<template>
  <ListTemplate
    :endPoint="endPoint"
    :title="title"
    :fields="fields"
    :actions="[]"
    :filterFields="filterFields"
    :tabList="[]"
    :refreshData="refreshData"
    @mode="changeMode"
    @show="showForm = true"
    :showForm="showForm"
    @data="handleData"
    :data="rows"
    :remote="false"
    :showHeader="false"
    :showQuickTour="false"
    :showQuickView="false"
    :showPagination="false"
    :ignorePermissions="true"
    :allowDisable="false"
    :show-actions="false"
    :ignore-max-height="true"
  >
    <template #form-view> </template>
  </ListTemplate>
</template>
